// extracted by mini-css-extract-plugin
export default {"base":"base-M1iux","empty":"empty-Uwa80","half":"half-BNaNq"};